import Text from '@web-ui-kit/text'
import { styled } from 'styled-components'
import COLORS from '@web-ui-kit/colors'
import { DEVICE_SIZE } from 'utils/constants'
import Modal from 'components/Modal'

export const CustomModal = styled(Modal)`
  background-color: ${COLORS.SECONDARY_50};
  margin: 0 1rem;
  max-width: 46.3125rem;
  padding: 3rem 2rem;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    margin: 0;
    padding: 3rem;
  }
`

export const Container = styled.article`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  & > h2 {
    text-align: center;
  }
`

export const CustomText = styled(Text)`
  text-align: center;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    text-align: initial;
  }
`

export const InfoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: -1.5rem;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    align-items: initial;
    flex-direction: row;
    gap: 3rem;
    margin-top: 0;
  }
`

export const Image = styled.img`
  margin: auto;
  max-width: 9.375rem;
  object-fit: contain;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    max-width: initial;
  }
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: space-between;
  & > ${CustomText}:first-of-type {
    order: -1;
    @media (min-width: ${DEVICE_SIZE.TABLET}) {
      order: 0;
    }
  }
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  @media (min-width: ${DEVICE_SIZE.TABLET}) {
    flex-direction: row;
    gap: 2rem;
    justify-content: center;
  }
  & > button {
    max-width: 12.5rem;
    text-transform: uppercase;
    @media (min-width: ${DEVICE_SIZE.TABLET}) {
      max-width: 15.625rem;
    }
    &:last-child {
      background-color: ${COLORS.SECONDARY_600};
      &:hover {
        background-color: ${COLORS.SECONDARY_300};
      }
      &:focus,
      &:active {
        background-color: ${({ theme }) => theme?.colors?.SECONDARY_900};
      }
    }
  }
`
